import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            const { is_firstLogin } = JSON.parse(userData);

            if (is_firstLogin === '1') {
                navigate('/login'); // Redirect to login page
            }
        }
    }, [navigate]);
};

export default useAuthRedirect;
